import { render, staticRenderFns } from "./NewsCarouselWidget.vue?vue&type=template&id=05e0db05&scoped=true"
import script from "./NewsCarouselWidget.vue?vue&type=script&lang=js"
export * from "./NewsCarouselWidget.vue?vue&type=script&lang=js"
import style0 from "./NewsCarouselWidget.vue?vue&type=style&index=0&id=05e0db05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e0db05",
  null
  
)

export default component.exports